import React from 'react';
import { StyleSheet, View } from 'react-native';
import { type ImageTransform } from 'cloudinary-tiny-js';
import { theme } from '@sg/garnish';
import { BodyText, FallbackImage, IllusEmpty_2 } from '@sg/garnish';

// ────────────────────────────────────────────────────────────────────────────────

export const OrderPlaybackLineItem = (props: OrderPlaybackLineItemProps) => {
  const { name, imageUrl, quantity } = props;

  return (
    <View style={styles.container}>
      <FallbackImage
        contentFit="contain"
        style={styles.image}
        baseUrl={imageUrl}
        defaultImage={IllusEmpty_2}
        cloudinaryConfig={CLOUDINARY_CONFIG}
      />

      <View style={styles.detailsColumn}>
        <BodyText
          bold
          sizeMatch={['18']}
          maxFontSizeMultiplier={1.2}
          numberOfLines={2}
        >
          {quantity > 1 ? `${quantity}x ${name}` : name}
        </BodyText>
      </View>
    </View>
  );
};

// ─── Constants ──────────────────────────────────────────────────────────────────

const THUMBNAIL_SIZE = 64;
const CLOUDINARY_CONFIG: readonly ImageTransform[] = [
  { crop: 'crop', height: 0.6, width: 0.4 },
  { width: THUMBNAIL_SIZE },
];

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingHorizontal: theme.spacing['1'],
    height: 80,
    alignItems: 'center',
    gap: theme.spacing['3'],
  },
  detailsColumn: {
    flex: 1,
    gap: theme.spacing['1'],
  },
  image: {
    width: THUMBNAIL_SIZE,
    height: THUMBNAIL_SIZE,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type OrderPlaybackLineItemProps = Readonly<{
  name: string;
  imageUrl?: string;
  quantity: number;
}>;
